/*
 *
 * UpfrontTdrDetails actions
 *
 */

import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  GET_PAYMENT_METHODS,
  GET_ACTIVE_GATEWAYS,
  GET_UPFRONT_TDR_PER_PAYMENT_METHOD,
  UPDATE_FILTERS,
  RESET_FILTERS,
  RESET_PAGE,
  SAVE_UPFRONT_TDR,
  UPDATE_UPFRONT_TDR,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function getPaymentMethodsAction(data) {
  return {
    type: GET_PAYMENT_METHODS,
    data,
  };
}

export function getUpfrontTDRPerPaymentMethods(data) {
  return {
    type: GET_UPFRONT_TDR_PER_PAYMENT_METHOD,
    data,
  };
}

export function getActiveGatewaysAction(data) {
  return {
    type: GET_ACTIVE_GATEWAYS,
    data,
  };
}

export function updateFiltersAction(data) {
  return {
    type: UPDATE_FILTERS,
    data,
  };
}

export function resetFiltersAction() {
  return {
    type: RESET_FILTERS,
  };
}

export function resetPageAction() {
  return {
    type: RESET_PAGE,
  };
}

export function saveUpfrontTDRAction(data) {
  return {
    type: SAVE_UPFRONT_TDR,
    data,
  };
}

export function updateUpfrontTDRAction(data) {
  return {
    type: UPDATE_UPFRONT_TDR,
    data,
  };
}
